<script lang="ts" setup>
import { LoaderOverlay } from '@UI/Loaders/LoaderOverlay'

defineOptions({
  name: 'SkeletonChangeWeeklySchedule',
})

</script>

<template>
  <div class="change-schedule__box skeleton">
    <LoaderOverlay />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Sections/Paid/DisciplineSchedule/SectionChangeWeeklySchedule.scss" />
